import styled from 'styled-components'
import { ListItem } from 'components/list'

export const DefaultContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 96px;
    position: relative;
`


export const ListContainer = styled(ListItem)`
    position: relative;
    margin: 0 32px 32px;
    height: 40px;
`